<script>
import { defineComponent } from "vue";
import { constructAddress, constructLocation, emitModel, getExternalModel, isEmptyPlace } from "@/composables/clientPickerShared";

export default defineComponent({
	name: "DeliveryEstablishment",
	model: {
		prop: "value",
		event: "input"
	},
	emits: ["input", "update:modelValue", "create-address", "edit-address"],
	props: {
		value: {
			type: Object,
			default: null
		},
		modelValue: {
			type: Object,
			default: null
		},
		establishments: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			emptyEstablishment: {
				id: 0,
				place: null,
				name: null
			}
		};
	},
	computed: {
		externalValue() {
			return getExternalModel(this.value, this.modelValue);
		},
		selectedEstablishment: {
			get() {
				if (this.externalValue !== null) return this.externalValue;
				return this.emptyEstablishment;
			},
			set(newValue) {
				emitModel(this, newValue);
			}
		}
	},
	methods: {
		constructAddress,
		constructLocation,
		isEmptyAddress() {
			return isEmptyPlace(this.selectedEstablishment);
		},
		onEstablishmentChange(establishment) {
			this.selectedEstablishment = establishment;
		},
		onCreateAddress() {
			this.$emit("create-address");
		},
		onEditAddress(establishment) {
			this.$emit("edit-address", establishment);
		}
	}
});
</script>

<template>
	<b-container class="mb-2">
		<b-row>
			<b-col cols="9" v-if="isEmptyAddress()">
				<div class="btn-link" style="cursor: pointer" @click="onCreateAddress">
					{{ $t("Aucune adresse renseignée") }}
				</div>
			</b-col>
			<b-col cols="9" v-else style="min-height: 40px">
				<div>{{ constructAddress(selectedEstablishment.place) }}</div>
				<div><span>{{ constructLocation(selectedEstablishment.place) }}</span></div>
			</b-col>
			<b-col cols="3" class="p-0 mt-0">
				<b-dropdown
					id="delivery-address"
					size="xs"
					:text="$t('Adresse')"
					class="mt-0"
					variant="light"
					style="border: 1px solid var(--border); border-radius: 5px; min-width: 70px"
				>
					<b-dropdown-item
						v-for="(establishment, index) in establishments"
						:key="`delivery_e_${establishment.id}`"
					>
						<b-row>
							<b-col cols="11" @click="onEstablishmentChange(establishment)">
								<div class="establishment-details text-gray">
									{{ establishment.name ? establishment.name : $t("établissement n°{index}", { index: (index + 1) }) }}
								</div>
								<div class="establishment-details">
									{{ constructAddress(establishment.place) }}<br>{{ constructLocation(establishment.place) }}
								</div>
							</b-col>
							<b-col cols="1" class="p-0 m-0">
								<b-icon
									@click="onEditAddress(establishment)"
									icon="pencil"
									style="height: 17px; width: 17px;"
								/>
							</b-col>
						</b-row>
					</b-dropdown-item>
					<b-dropdown-item class="text-center">
						<b-button
							variant="link"
							class="establishment-details"
							@click="onCreateAddress"
						>
							{{ $t("Ajouter un établissement") }}
						</b-button>
					</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</b-row>
	</b-container>
</template>
